import React from 'react';
import cls from 'classnames';
import { SwitchTransition } from 'react-transition-group';
import { useCurrentStateAndParams, useRouter } from '@wix/tpa-router/react';
import {
  ErrorMonitorBoundary,
  Trans,
  useEnvironment,
  useTranslation,
} from '@wix/yoshi-flow-editor';

import { Container } from 'wui/Container';
import { ErrorState } from 'wui/ErrorState';
import { Fade } from 'wui/Fade';

import { ROUTES } from './constants';

import classes from './ApplicationPage.scss';

export function ApplicationPage() {
  const { state } = useCurrentStateAndParams();
  const { isMobile } = useEnvironment();
  const { t } = useTranslation();
  const router = useRouter();

  const active = ROUTES.find((item) => state?.name?.includes(item.state));
  const Page = active?.component || null;

  return (
    <SwitchTransition>
      <Fade key={state.name}>
        <Container
          as="section"
          role="region"
          fluid={isMobile}
          aria-labelledby={state.data?.application}
          className={cls(classes.root, {
            [classes.mobile]: isMobile,
          })}
        >
          <ErrorMonitorBoundary
            fallback={
              <ErrorState
                wired
                title={t('groups-web.discussion.error-state.title')}
                subtitle={
                  <Trans
                    i18nKey={t(
                      'groups-web.discussion.error-state.owner.message',
                    )}
                    components={[<span />, <br />, <span />]}
                  />
                }
                actionLabel={t('groups-web.discussion.error-state.cta')}
                onRetry={handleRetry}
              />
            }
          >
            {Page ? <Page /> : null}
          </ErrorMonitorBoundary>
        </Container>
      </Fade>
    </SwitchTransition>
  );

  function handleRetry() {
    router.reload();
  }
}

ApplicationPage.displayName = 'ApplicationPage';
